import type { OnePasswordConnectorHosting } from "@p0security/integrations-one-password-shared/types";

/** A connector image on Docker Hub, pinned by the digest its tag resolves
 * to. */
export type ConnectorImage = Readonly<{
  /** `sha256:<digest>` */
  digest: string;
  name: string;
  tag: string;
}>;

/** The connector build each cloud deploys: one image for AWS Lambda and one
 * for Cloud Run, built from the same service.
 *
 * Each is a p0-security-perimeter build of the connector, by its
 * `sha-<commit>` tag on Docker Hub and the digest that tag resolves to
 * (`docker buildx imagetools inspect <name>:<tag>`). The service's source has
 * moved to `submodules/connector`, but these pins still name perimeter builds
 * until they're moved to that repo's images. */
export const CONNECTOR_IMAGES: Readonly<
  Record<OnePasswordConnectorHosting["type"], ConnectorImage>
> = {
  aws: {
    digest:
      "sha256:01fc086e833c1ffcfef94ff49d1c9959cd8135a1fdc7ea1dc02eae5abb5d687b",
    name: "p0security/p0-connector-1password",
    tag: "sha-f1af73d",
  },
  gcp: {
    digest:
      "sha256:5c8f2d547a031202886bc31e4ef84d700a2fd05960fde7d0eda1b8bc2580e3ae",
    name: "p0security/p0-connector-1password-gcloud",
    tag: "sha-f1af73d",
  },
};
